<!-- 风控预警 -->
<template>
  <div class="frame">
    <img
      src="http://api.zyzxgc.cn/file/static/banner_product.jpg"
      class="banner"
    />
    <div class="wrap">
      <div class="breadcrumb w1200">
        <bread-crumb :breadcrumbs="routerHistory"></bread-crumb>
      </div>
      <sub-nav :subNavs="subNavs"></sub-nav>
      <div class="container w1200">
        <sub-title title="风控预警" en="RISK CONTROL WARNING"></sub-title>
        <div class="box">
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img1.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">工期风险</div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img2.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">安全风险</div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img3.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">履约风险</div>
          </div>
        </div>
        <div class="box">
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img4.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">质量风险</div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img5.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">成本风险</div>
          </div>
          <div class="item">
            <img
              src="http://api.zyzxgc.cn/file/static/warning_img6.png"
              class="post"
            />
          </div>
          <div class="item">
            <div class="label">......</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
import breadCrumb from "@/components/breadCrumb.vue";
import SubNav from "@/components/subNav.vue";
import SubTitle from "@/components/subTitle.vue";
export default {
  components: { breadCrumb, SubNav, SubTitle },
  data() {
    return {
      routerHistory: [], // 当前所在位置
      subNavs: [],
    };
  },
  computed: {
    ...mapState(Store, ["navList"]),
  },
  created() {
    this.formatBreadCrumb();
  },
  mounted() {},
  methods: {
    // 格式化导航条和二级导航栏
    formatBreadCrumb() {
      let nav = this.navList.find(
        (ele) => ele.path != "/" && this.$route.path.includes(ele.path)
      );
      if (nav.subs && nav.subs.length != 0) {
        // 二级导航栏
        this.subNavs = nav.subs;
      }
      this.routerHistory = [{ path: "/", name: "首页" }, nav];
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  .banner {
    width: 100%;
    display: block;
  }
  .wrap {
    background-image: url("http://api.zyzxgc.cn/file/static/qualityIdea_bg.png");
    background-size: cover;
    background-position-x: center;

    &::before,
    &::after {
      content: "";
      display: table;
    }
  }
  .breadcrumb {
    margin: 25px auto 20px;
  }
  .container {
    margin: 70px auto 120px;

    .box {
      margin-top: 100px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;

      .item {
        width: 380px;
        height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .post {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .label {
          font-size: 31px;
          color: #5e5d5d;
        }
      }
    }
  }
}

@media (max-width: 750px) {
  .frame {
    .banner {
      height: auto;
    }
    .breadcrumb {
      display: none;
    }
    .container {
      margin: 20px 0;
      padding: 0 10px;
      box-sizing: border-box;

      .box {
        margin-top: 50px;

        .item {
          width: 50%;
          height: 135px;

          .label {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
